import { gql } from '@apollo/client';

import { buildQueryHook } from '../../../utils/buildQueryHook';
import {
  IsFeatureFlagEnabled,
  IsFeatureFlagEnabledVariables,
} from '../../athena/types/IsFeatureFlagEnabled';

export const IS_FEATURE_FLAG_ENABLED = gql`
  query IsFeatureFlagEnabled(
    $featureFlag: String!
    $userId: String!
    $props: GoogleProtobuf_StructInput
  ) {
    variant {
      getFeatureFlags(
        input: {
          keys: [$featureFlag]
          grain: { grain: { operator: { primaryId: { humanToken: $userId } } } }
          props: $props
        }
      ) {
        variants {
          key
          value {
            value
          }
        }
      }
    }
  }
`;

export default buildQueryHook<IsFeatureFlagEnabled, IsFeatureFlagEnabledVariables, boolean>(
  IS_FEATURE_FLAG_ENABLED,
  {
    wrangler: (data: IsFeatureFlagEnabled) => {
      return data?.variant?.getFeatureFlags?.variants?.[0]?.value?.value === 'on';
    },
  },
);
